import { useSelector, useDispatch } from "react-redux";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import {
    selectIsSfSettingsChanged,
    selectNotification,
} from "../../../sub-modules/management/store/selectors/salesforce/exportSelectors";
import {
    selectHsNotification,
    selectIsHsSettingsChanged,
} from "../../../sub-modules/management/store/selectors/hubspot/exportSelectors";
import {
    selectDynamicsNotification,
    selectIsDynamicsSettingsChanged,
} from "../../../sub-modules/management/store/selectors/dynamics/exportSelectors";
import { setHsNotification } from "app/pages/sales-intelligence/sub-modules/management/store/actions/export/hubspot";
import { setSfNotification } from "app/pages/sales-intelligence/sub-modules/management/store/actions/export/salesforce";
import { setDynamicsNotification } from "app/pages/sales-intelligence/sub-modules/management/store/actions/export/dynamics";
import type { ExportNotification } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import { revertHsSettingsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/export";
import { revertSettingsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/export";
import { revertDynamicsSettingsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/export";
import type { UseDiscardModalPropsType } from "./type";

export const useDiscardModalProps = (integrationName: Integration): UseDiscardModalPropsType => {
    const allProps = {
        salesforce: {
            setNotificationAction: setSfNotification,
            revertSettings: revertSettingsThunk,
            isSettingsChangedAction: selectIsSfSettingsChanged,
            selectNotificationItem: selectNotification,
        },
        hubspot: {
            setNotificationAction: setHsNotification,
            revertSettings: revertHsSettingsThunk,
            isSettingsChangedAction: selectIsHsSettingsChanged,
            selectNotificationItem: selectHsNotification,
        },
        dynamics: {
            setNotificationAction: setDynamicsNotification,
            revertSettings: revertDynamicsSettingsThunk,
            isSettingsChangedAction: selectIsDynamicsSettingsChanged,
            selectNotificationItem: selectDynamicsNotification,
        },
    };

    const dispatch = useDispatch();

    const { setNotificationAction, revertSettings, isSettingsChangedAction, selectNotificationItem } =
        allProps[integrationName];

    const setNotification = (notification: ExportNotification) => dispatch(setNotificationAction(notification));
    const revertSettingsExport = () => dispatch(revertSettings());
    const isSettingsChanged = useSelector(isSettingsChangedAction);
    const notification = useSelector(selectNotificationItem);

    return {
        setNotification,
        revertSettingsExport,
        isSettingsChanged,
        notification,
    };
};
